import { useEffect } from 'react';

import { useGetAiServicesQuery } from '@app/api/AiServices';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const usePaidAiFeaturesEffects = () => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const {
    data,
    isLoading: isDataLoading,
    error,
  } = useGetAiServicesQuery({ ActiveBranchId }, { skip: !ActiveBranchId });

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return { data, isDataLoading, ActiveBranchId };
};
